import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * «Alguien propuso un encuentro», en la campanita del EQUIPO (T-FORO-V14).
 *
 * Gemela de `GroupRequestNotification` — ver su cabecera para el porqué de existir aunque el
 * driver `alert` no sea opcional. Lo que cambia es el destino: esta notificación sólo la reciben
 * admins (`ProposeMeetupHandler::notifyAdmins()`), y lo que hay que ver no es una página propia
 * del foro sino la cola de solicitudes del panel — de ahí el enlace directo a `/admin`.
 */
export default class MeetupRequestNotification extends Notification {
  icon() {
    return 'fas fa-calendar-plus';
  }

  href() {
    // Directo al panel, sección de la extensión — la cola de solicitudes vive ahí (`ComunidadPage`
    // admin), no en una página pública, porque la propuesta nunca se publica.
    return app.forum.attribute('baseUrl') + '/admin#/extension/umbral-comunidad';
  }

  content() {
    // El tema sale del contenido del propio aviso (`{topic: ...}`), igual que
    // `GroupRequestNotification`: el listado pinta muchas notificaciones de golpe y consultar la
    // solicitud de cada una sería una petición por fila.
    const content: any = this.attrs.notification.content() || {};

    return app.translator.trans('umbral-comunidad.forum.notifications.meetup_request_submitted', {
      topic: content.topic || '',
    });
  }
}
